


































import { listFactory } from '@/main/pages';
import { apiProvider } from '@/modules/administrace/serviceOrderHistory/api';
import { openEdit } from '@/main/router/routerPath';
import { NAME, PdiSelected, WithoutPdiSelected } from './constants';
import { store } from './store/list';
import { PageMode } from '@/main/utils/pageMode';
import DmsPdfDialog from '#components/DmsPdfDialog.vue';

export default listFactory(NAME, store).extend({
	components: { DmsPdfDialog },
	
		mounted(){
		var element = document.getElementsByClassName("el-main");
					if(element.length!=0)
						element[0].classList.remove('d-flex');
		},
	computed:{
			isExportButtonVisible(){
				return this.table.rows.length > 0;
			}
		},
	methods:{
		viewClick(event: any) {
			openEdit(NAME, PageMode.VIEW, { id: event.data.SERVICE_ORDER_HISTORYID });
		},
		async onPdiChange(){
			if(this.localState.pdiOptionSelection == WithoutPdiSelected)
			this.filter.WithPdi = false;
			else if(this.localState.pdiOptionSelection == PdiSelected){
				this.filter.WithPdi = true;
			}
		},
	async searchData() {
			this.startLoading();
			this.filter.VINOrRegistrationNumber= this.localState.VINorRegistrationNumber;
			this.tableData();
			this.endLoading();
		},
		async exportData() {
			this.startLoading();
			const columnsSeq = this.table.columns.filter(x => x.isVisible === true).map(x => x.columnName);
			await apiProvider.GetFullServiceOrderReports(this.filter.VINOrRegistrationNumber, this.filter.WithPdi, columnsSeq);
			this.endLoading();
		},
		async showServiceHistoryReport() {
			this.localState.tiskDialog.fetchPdfProvider = () => apiProvider.getServiceHistoryReport(this.filter.VINOrRegistrationNumber, this.filter.WithPdi);
			this.localState.tiskDialog.visible = true;
		},
	},
});
